const GF_REACT_ROOT = '_gf_react_root';
export default function getReactRoot() {
  if (typeof window !== 'undefined') {
    return window[GF_REACT_ROOT];
  }
  return null;
}
